/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  function formatMoney(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(value);
  }


  function updateLoopPrices(quantityCounter) {
    const productScope =
      quantityCounter.closest('product-component') ||
      quantityCounter.closest('[data-product]') ||
      document;

    const quantityInput = quantityCounter.querySelector(
      '[data-quantity-field]'
    );

    const loopWidget = productScope.querySelector(
      '.loop-widget-container'
    );

    if (!quantityInput || !loopWidget) return;

    const quantity = Math.max(
      1,
      parseInt(quantityInput.value || '1', 10)
    );

    const oneTimePrice = loopWidget.querySelector(
      '.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price'
    );

    const subscriptionOption = loopWidget.querySelector(
      '[data-loop-widget-selling-plan-group]'
    );

    const subscriptionPrice = subscriptionOption?.querySelector(
      '.loop-widget-purchase-option-price'
    );

    const comparePrice = subscriptionOption?.querySelector(
      '.loop-widget-purchase-option-compare-at-price'
    );

    if (!oneTimePrice || !subscriptionPrice) return;


    /*
     * Store the original per-unit prices once.
     */
    if (!loopWidget.dataset.teinOneTimePrice) {
      loopWidget.dataset.teinOneTimePrice = '48';
    }

    if (!loopWidget.dataset.teinSubscriptionPrice) {
      loopWidget.dataset.teinSubscriptionPrice = '40.8';
    }

    if (!loopWidget.dataset.teinComparePrice) {
      loopWidget.dataset.teinComparePrice = '48';
    }


    const oneTimeUnit = Number(
      loopWidget.dataset.teinOneTimePrice
    );

    const subscriptionUnit = Number(
      loopWidget.dataset.teinSubscriptionPrice
    );

    const compareUnit = Number(
      loopWidget.dataset.teinComparePrice
    );


    oneTimePrice.textContent =
      formatMoney(oneTimeUnit * quantity);

    subscriptionPrice.textContent =
      formatMoney(subscriptionUnit * quantity);

    if (
      comparePrice &&
      !comparePrice.classList.contains('loop-display-none')
    ) {
      comparePrice.textContent =
        formatMoney(compareUnit * quantity);
    }
  }


  /**
   * Plus / Minus buttons
   */
  document.addEventListener('click', function(event) {
    const button = event.target.closest(
      '[data-quantity-plus], [data-quantity-minus]'
    );

    if (!button) return;

    const quantityCounter = button.closest(
      'quantity-counter'
    );

    if (!quantityCounter) return;

    setTimeout(function() {
      updateLoopPrices(quantityCounter);
    }, 0);
  });


  /**
   * Manual quantity entry
   */
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-quantity-field]')) return;

    const quantityCounter = event.target.closest(
      'quantity-counter'
    );

    if (!quantityCounter) return;

    updateLoopPrices(quantityCounter);
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
